/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseFlyerToolbarSettings
 */
export interface DatabaseFlyerToolbarSettings {
    /**
     * Die Leiste UNTER der Karte: Blätterpfeile, Neustart, Rechtstexte.
     * @type {boolean}
     * @memberof DatabaseFlyerToolbarSettings
     */
    enabled?: boolean;
    /**
     * BLAETTERN DURCH WISCHEN auf Telefon und Tablet.
     * 
     * Betreiber 14.09.2026: „Ich moechte gern das Swipen verhindern.
     * Hierzu brauche ich eine Einstellung."
     * 
     * WOFUER ABSCHALTEN: Auf einer Karte, die BEDIENT wird — Schlaege
     * zaehlen, Namen eintragen —, liegt der Finger staendig auf der
     * Flaeche. Ein Wischen, das dabei eine Seite weiterblaettert, wirft
     * den Gast mitten im Spiel auf die Auswertung. Wer nur blaettern
     * laesst (Broschuere, Einladung), laesst es an.
     * 
     * Ohne Angabe bleibt es AN — keine bestehende Datenbank aendert
     * sich.
     * @type {boolean}
     * @memberof DatabaseFlyerToolbarSettings
     */
    wischen?: boolean;
    /**
     * DIE ZWEI KNOEPFE UEBER DER KARTE — „Datensatz hinzufügen" und
     * „Listenansicht". Sie sehen nur angemeldete Benutzer, nie ein Gast.
     * 
     * WOFUER DER SCHALTER: Die beiden Knoepfe kamen am 09.05.2026 fuer
     * die E-Cards („feat(ecard): Toolbar mit zwei Buttons") — dort legt
     * der Betreiber Karte fuer Karte an und braucht sie beim Arbeiten.
     * Auf einer Karte, die ein GAST bedient (Scorecard, Fragebogen,
     * Anmeldung), stehen sie mitten im Kundenbild: Der Betreiber schaut
     * sich seine Karte an und sieht zwei Editierknoepfe, die der Gast
     * nie hat.
     * 
     * Ohne Angabe bleiben sie sichtbar — jede bestehende Datenbank
     * bleibt damit, wie sie ist. Wer sie abschaltet, erreicht die
     * Listenansicht weiterhin ueber das Konto-Menue (Avatar oben rechts)
     * und das Anlegen dort ueber „Neu".
     * @type {boolean}
     * @memberof DatabaseFlyerToolbarSettings
     */
    betreiberWerkzeuge?: boolean;
}

/**
 * Check if a given object implements the DatabaseFlyerToolbarSettings interface.
 */
export function instanceOfDatabaseFlyerToolbarSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFlyerToolbarSettingsFromJSON(json: any): DatabaseFlyerToolbarSettings {
    return DatabaseFlyerToolbarSettingsFromJSONTyped(json, false);
}

export function DatabaseFlyerToolbarSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFlyerToolbarSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'wischen': !exists(json, 'wischen') ? undefined : json['wischen'],
        'betreiberWerkzeuge': !exists(json, 'betreiberWerkzeuge') ? undefined : json['betreiberWerkzeuge'],
    };
}

export function DatabaseFlyerToolbarSettingsToJSON(value?: DatabaseFlyerToolbarSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'wischen': value.wischen,
        'betreiberWerkzeuge': value.betreiberWerkzeuge,
    };
}

